import React, { useRef } from 'react'
import {
  SCModalCloseButton, SCModalCloseIcon,
  SCModalContent,
  SCModalContentText, SCModalContentTitle,
  SCModalOverlay, SCTopBarIcon, SCTopBarInfo,
} from 'components/AugmentedReality/Structure/ModalInfos/styled'
import ReactHtmlParser from 'react-html-parser'
import infosImg from '../../../../../public/static/ra/infos.svg';
import closeImg from '../../../../../public/static/ra/close.svg';
import ReactPlayer from 'react-player';
import { useTranslation } from 'react-i18next';

interface ModalInfosProps {
  title: string;
  text: string;
  video: string;
  onClose: () => void;
}
const ModalInfos = ({ title, text, video, onClose }: ModalInfosProps) => {
  const { t } = useTranslation();
  const playerRef = useRef();

  const defaultText = <>
    <p>{t('augmentedReality.modalInfos.defaultText1')}</p>
    <p>{t('augmentedReality.modalInfos.defaultText2')}</p>
    <p>{t('augmentedReality.modalInfos.defaultText3')}</p>
    <p>{t('augmentedReality.modalInfos.defaultText4')}</p>
    <p>{t('augmentedReality.modalInfos.defaultText5')}</p>
    <p>{t('augmentedReality.modalInfos.defaultText6')}</p>
    <p>{t('augmentedReality.modalInfos.defaultText7')}</p>
  </>
  return (
    <SCModalOverlay onClick={onClose}>
      <SCTopBarInfo>
        <SCTopBarIcon src={infosImg.src} alt="info" />
      </SCTopBarInfo>
      <SCModalContent onClick={(e) => e.stopPropagation()} $opacity $type="infos" $hasVideo={!!video}>
        <SCModalCloseIcon src={closeImg.src} onClick={onClose} />

        <SCModalContentTitle>{!!title ? title : t('augmentedReality.modalInfos.defaultTitle')}</SCModalContentTitle>
        {video && (
          <div className="video-container">
            <ReactPlayer
              className="react-player"
              ref={playerRef}
              url={video}
              height="100%"
              width="100%"
              controls
              playsinline
              config={{
                file: {
                  attributes: {
                    playsInline: true,
                    webkit_playsinline: "true"
                  }
                }
              }}
            />
          </div>
        )}
        <SCModalContentText $hasVideo={!!video}>
          {!!text? ReactHtmlParser(text) : defaultText}
        </SCModalContentText>

        <SCModalCloseButton onClick={onClose}>{t('augmentedReality.modalInfos.close')}</SCModalCloseButton>
      </SCModalContent>
    </SCModalOverlay>
  );
}

export default ModalInfos;
